var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"iframe"},[_c('iframe',{staticClass:"formIframe",attrs:{"frameborder":"0","id":_vm.frameId,"src":_vm.formSrc}})])
}
var staticRenderFns = []

export { render, staticRenderFns }